import { render, staticRenderFns } from "./wy-interactions-compare-metrics-result.vue?vue&type=template&id=579a4640&"
import script from "./wy-interactions-compare-metrics-result.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-compare-metrics-result.vue?vue&type=script&lang=js&"
import style0 from "./wy-interactions-compare-metrics-result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports